export default __webpack_public_path__ + "static/media/open_bite.d3ff5161.png";